import React from 'react';
import './ModalMenu.styles.scss';
import Viber from '../../assets/images/viber.svg';
import Insta from '../../assets/images/Insta.svg';
import Whatsapp from '../../assets/images/whatsapp.svg';
import FaceBook from '../../assets/images/Facebook.svg';
import VK from '../../assets/images/vk.svg';
import Max from '../../assets/images/max.svg';
import AnchorLink from "react-anchor-link-smooth-scroll";

const ModalMenu = ({ closeMenu }) => {
    return (
        <div className='modal-menu'>
            <div className='container'>
                <ul className='modal-menu-wrapper'>
                    <li className="modal-menu-item">
                        {window.location.pathname === '/thank-you' ? (
                            <ul className='modal-menu-link'>
                                <li>
                                    <a href="/" className='anchor-link'>Для частных клиентов</a>
                                </li>
                                <li>
                                    <a href="/for-companies" className='anchor-link'>Для компаний</a>
                                </li>
                            </ul>
                        ) : (
                            <ul className='modal-menu-link'>
                                <li>
                                    <   AnchorLink href="#kontakt" className='anchor-link'
                                        onClick={closeMenu}
                                    >Контакты</AnchorLink>
                                </li>
                                <li>
                                    {window.location.pathname === '/' &&
                                        <a href="/for-companies" className='anchor-link'>Для компаний</a>
                                    }
                                    {window.location.pathname === '/for-companies' &&
                                        <a href="/" className='anchor-link'>Для частных клиентов</a>
                                    }
                                </li>
                            </ul>
                        )}
                    </li>
                    {window.location.pathname === '/' &&
                        <li className="modal-menu-item">
                            <button className="button" type="button">
                                <AnchorLink href="#uslugi" onClick={closeMenu}>Заказать онлайн</AnchorLink>
                            </button>
                        </li>
                    }
                    {window.location.pathname === '/for-companies' &&
                        <li className="modal-menu-item">
                            <button className="button" type="button">
                                <AnchorLink href="#skontaktuj"
                                    onClick={closeMenu}
                                >Свяжитесь с нами</AnchorLink>
                            </button>
                        </li>
                    }
                    <li className="modal-menu-item">
                        <ul className='social-list'>
                           <li className="social-list__item">
                                <a href='https://vk.com/belo_klining' target='__blank' className="social-list__link">
                                    <img src={VK} alt="ВКонтакте" />
                                </a>
                            </li>
                            <li className="social-list__item">
                                <a href='https://max.ru/belo_klining' target='__blank' className="social-list__link">
                                    <img src={Max} alt="МАКС" />
                                </a>
                            </li>
                        </ul>
                    </li>

                    <li className="modal-menu-item">
                            <a href="https://alpairya.ru" target='__blank' className='modal-link'>Разработка ПО и Приложений</a>
                        </li>
                </ul>
            </div>
        </div>
    );
};

export default ModalMenu;